import { users as usersService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../../../error/state';
import logger from '../../../../../../common/services/logService';
import Types from '../types';

export const listNotificationsStart = () => ({
  type: Types.LIST_NOTIFICATIONS_START,
});

export const listNotificationsEnd = () => ({
  type: Types.LIST_NOTIFICATIONS_END,
});

export default ({ callback }) =>
  async dispatch => {
    try {
      dispatch(listNotificationsStart());
      const { data } = await usersService.listNotifications();
      if (callback) callback(data);
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(listNotificationsEnd());
    }
  };
